import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '@/contexts/AuthContext'
import { FullPageLoading } from '@/components/ui/LoadingSpinner'

export function AuthCallbackPage() {
  const navigate = useNavigate()
  const { isAuthenticated, isLoading } = useAuth()

  useEffect(() => {
    // Wait for auth state to be determined by AuthContext
    // The AuthContext will handle fetching the user data
    if (!isLoading) {
      if (isAuthenticated) {
        // User is authenticated, redirect to dashboard
        navigate('/dashboard', { replace: true })
      } else {
        // Authentication failed, redirect to login
        navigate('/login', { replace: true })
      }
    }
  }, [isAuthenticated, isLoading, navigate])

  return (
    <FullPageLoading message="Completing authentication..." />
  )
}